/**
 * Materials Tab
 * 
 * TODO: Copy from SMBeamDesigner.tsx lines 1820-2554
 * Look for: {activeStep === 'materials' && (
 * Copy everything inside including the <div> wrapper
 */

import React from 'react'
import { SMBeamModel, SectionMaterialStrength } from '../types'
import { ResizablePanels } from '@structura/ui'
import { useResizablePanels } from '@structura/ui'
import { UseMaterialStateResult } from '../hooks/useMaterialState'
import MaterialFormPanel from './materials/MaterialFormPanel'
import MaterialVisualizationPanel from './materials/MaterialVisualizationPanel'

interface MaterialsTabProps {
  model: SMBeamModel
  setModel: React.Dispatch<React.SetStateAction<SMBeamModel>>
  materialState: UseMaterialStateResult
  sectionMaterialStrength?: SectionMaterialStrength | null
}

const MaterialsTab: React.FC<MaterialsTabProps> = ({
  model,
  setModel,
  materialState,
  sectionMaterialStrength
}) => {
  const { currentMaterial, timberKind } = materialState

  const { leftWidth, rightWidth, handleMouseDown, isDragging, containerRef } = useResizablePanels({
    defaultLeftWidth: 35,
    minLeftWidth: 3,
    maxLeftWidth: 97,
    storageKey: 'beamDesigner_materialsTab_leftWidth'
  })

  return (
    <ResizablePanels
      leftPanel={
        <MaterialFormPanel
          model={model}
          setModel={setModel}
          materialState={materialState}
        />
      }
      rightPanel={
        <MaterialVisualizationPanel
          model={model}
          currentMaterial={currentMaterial}
          timberKind={timberKind}
          sectionMaterialStrength={sectionMaterialStrength ?? null}
        />
      }
      leftWidth={leftWidth}
      rightWidth={rightWidth}
      onMouseDown={handleMouseDown}
      isDragging={isDragging}
      containerRef={containerRef}
    />
  )
}

export default MaterialsTab
